import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

const ADDRESS_FIELDS = gql`
  fragment addressFields on BusinessAddress {
    address1
    address2
    city
    state
    zip
  }
`;

export const GET_BUSINESS_ENTITY_QUERY = gql`
  query BusinessEntityProfileQuery($businessEntityUuid: UUID!) {
    businessEntity: businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      name
      type
      domesticJurisdiction
      createdAt
      updatedAt
      formationDate
      ein
      addresses {
        mailing {
          ...addressFields
        }
        principal {
          ...addressFields
        }
      }
    }
  }
  ${ADDRESS_FIELDS}
`;

export const GET_REGISTERED_AGENTS_QUERY = gql`
  query RegisteredAgentsProfileQuery($businessEntityUuid: UUID!) {
    registeredAgents: registeredAgents(businessEntityUuid: $businessEntityUuid) {
      uuid
      contact {
        fullName
        addressLine1
        addressLine2
        city
        state
        zip
      }
    }
  }
`;

export function useBusinessProfile() {
  const { businessEntityUuid } = useBusinessEntity();

  const {
    data: businessEntityData,
    loading: entityLoading,
    error: entityError,
  } = useQuery(GET_BUSINESS_ENTITY_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
    },
  });

  const {
    data: registeredAgentsData,
    loading: agentsLoading,
    error: agentsError,
  } = useQuery(GET_REGISTERED_AGENTS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
    },
  });

  useError(entityError);
  useError(agentsError);

  return {
    data: {
      businessEntity: businessEntityData?.businessEntity,
      registeredAgents: registeredAgentsData?.registeredAgents,
    },
    error: entityError,
    loading: entityLoading,
    registeredAgentsLoading: agentsLoading,
    registeredAgentsError: !!agentsError,
  };
}
